import React from "react";
import { Bell, Calendar, Clock, CheckCircle2, XCircle, AlertCircle } from "lucide-react";
import { Badge } from "../ui/badge";

export const getNotificationIcon = (type) => {
  const icons = {
    SCHEDULE_CHANGED: Calendar,
    OVERRIDE_PENDING: Clock,
    OVERRIDE_APPROVED: CheckCircle2,
    OVERRIDE_REJECTED: XCircle,
    CYCLE_UPDATED: Calendar,
    ASSIGNMENT_CHANGED: AlertCircle,
  };
  return icons[type] || Bell;
};

export const getNotificationColor = (priority) => {
  const colors = {
    LOW: "text-blue-500",
    MEDIUM: "text-yellow-500",
    HIGH: "text-orange-500",
    URGENT: "text-red-500",
  };
  return colors[priority] || "text-muted-foreground";
};

export const getPriorityBadge = (priority, t) => {
  const config = {
    LOW: { color: "bg-muted text-muted-foreground", label: t("planning.legacy.notifications.priorities.low") },
    MEDIUM: { color: "bg-yellow-950/30 text-yellow-400", label: t("planning.legacy.notifications.priorities.medium") },
    HIGH: { color: "bg-orange-950/30 text-orange-400", label: t("planning.legacy.notifications.priorities.high") },
    URGENT: { color: "bg-red-950/30 text-red-400", label: t("planning.legacy.notifications.priorities.urgent") },
  };
  const { color, label } = config[priority] || config.MEDIUM;
  return <Badge className={color}>{label}</Badge>;
};

export const formatDate = (dateStr, t, language) => {
  const date = new Date(dateStr);
  const diffMs = Date.now() - date;
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMins / 60);
  const diffDays = Math.floor(diffHours / 24);

  if (diffMins < 1) return t("planning.legacy.notifications.relative.now");
  if (diffMins < 60) return t("planning.legacy.notifications.relative.minutes", { count: diffMins });
  if (diffHours < 24) return t("planning.legacy.notifications.relative.hours", { count: diffHours });
  if (diffDays < 7) return t("planning.legacy.notifications.relative.days", { count: diffDays });

  return new Intl.DateTimeFormat(language, { day: "2-digit", month: "short", year: "numeric" }).format(date);
};
